export default __webpack_public_path__ + "static/media/patient-room-v5.e638d2b2.png";